var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoBDouin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo_BDouin",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 216.875,
    height: 195.342,
    viewBox: "0 0 216.875 195.342",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1430",
    "data-name": "Rectangle 1430",
    width: 216.875,
    height: 195.342,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5256",
    "data-name": "Group 5256"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5255",
    "data-name": "Group 5255",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8926",
    "data-name": "Path 8926",
    d: "M29.086,300.548c5.024-2.1,12.545-5.5,12.545-15.549,0-10.57-9.969-16.161-23.365-16.161H.773c-.516,0-.773.262-.773.524s.644.524.9.786l3.864,2.534a2.625,2.625,0,0,1,1.16,2.446l1.39,52.937a2.626,2.626,0,0,1-1.16,2.446l-3.864,2.533c-.258.35-.9.524-.9.786s.257.524.773.524H22.387c10.563,0,19.5-6.028,19.5-18.694,0-9.7-7.779-13.365-12.8-15.112m-7.858,29.439H17.235V303.256h1.932c6.312,0,9.017,3.232,9.017,11.793,0,11.793-1.288,14.938-6.956,14.938m-2.061-31.1H17.235V273.206h1.932c6.312,0,9.017,2.883,9.017,11.793,0,10.483-2.7,13.89-9.017,13.89",
    transform: "translate(0 -139.052)",
    fill: "#d3d3d3",
    fillRule: "evenodd"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5258",
    "data-name": "Group 5258"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5257",
    "data-name": "Group 5257",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8927",
    "data-name": "Path 8927",
    d: "M191.237,303.763c-8.229.5-14.869,5.894-13.823,23.071,1.312,21.537,8.547,25.91,16.776,25.409,8.357-.509,15.008-5.728,13.7-27.265-1.046-17.177-8.292-21.724-16.65-21.215m2.724,44.73c-3.343.2-5.324-2.651-6.518-22.27-.924-15.171.679-18.507,4.022-18.711,3.472-.211,5.468,2.905,6.392,18.077,1.194,19.618-.425,22.692-3.9,22.9m55.252,2.945-3.993-3.057a1.369,1.369,0,0,1-.128-.786V304.354c0-.349-.129-.524-.644-.524H232.081c-.387,0-.773.087-.773.349,0,.175.258.437.644.7l3.736,2.446a.742.742,0,0,1,.387.7v33.632c0,4.28-2.705,6.988-5.8,6.988-3.349,0-5.024-1.747-5.024-5.067V307.134c0-.35-.258-.524-.644-.524H212.243c-.386,0-.773.087-.773.349,0,.175.258.437.516.7l3.865,2.446a.743.743,0,0,1,.386.7v32.686c0,5.94,3.478,8.91,10.949,8.91a12.6,12.6,0,0,0,8.631-3.32h.258v2.97c0,.175.386.349.9.349h11.98c.516,0,.9-.087.9-.349,0-.175-.257-.437-.644-.612m19.984,0-3.993-3.057c-.258-.175-.258-.437-.258-.786V304.354c0-.349-.257-.524-.644-.524l-14.336.116c-.387,0-.773.087-.773.349,0,.175.257.437.515.7l3.865,2.446a.743.743,0,0,1,.386.7l1.97,39.456c0,.35,0,.612-.257.786l-3.993,3.057c-.258.175-.515.437-.515.612,0,.262.386.349.773.349h17c.515,0,.773-.087.773-.349,0-.175-.258-.437-.515-.612m38.871,0-3.993-3.057c-.257-.175-.257-.437-.257-.786l.811-34.855c0-5.853-4.251-8.91-10.692-8.91a13.412,13.412,0,0,0-8.888,3.057h-.258v-2.534c0-.349-.129-.524-.644-.524H271.78c-.386,0-.772.087-.772.349,0,.175.257.437.515.7l3.865,2.446a.743.743,0,0,1,.386.7v39.572c0,.35,0,.612-.257.786l-3.993,3.057c-.387.175-.515.437-.515.612,0,.262.257.349.772.349h17c.386,0,.773-.087.773-.349,0-.175-.258-.437-.644-.612l-3.993-3.057a1.364,1.364,0,0,1-.129-.786V315.186c0-4.717,3.349-7.6,6.441-7.6,2.963,0,4.38,1.747,4.38,5.067l-.811,34.942c0,.35,0,.612-.258.786l-3.993,3.057c-.257.175-.515.437-.515.612,0,.262.258.349.773.349h17c.387,0,.773-.087.773-.349,0-.175-.257-.437-.515-.612",
    transform: "translate(-91.708 -157.097)",
    fill: "#d3d3d3",
    fillRule: "evenodd"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5260",
    "data-name": "Group 5260"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5259",
    "data-name": "Group 5259",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8928",
    "data-name": "Path 8928",
    d: "M337.176,266.331a6.778,6.778,0,1,0,6.778,6.778,6.778,6.778,0,0,0-6.778-6.778",
    transform: "translate(-170.893 -137.756)",
    fill: "#d3d3d3",
    fillRule: "evenodd"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5262",
    "data-name": "Group 5262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5261",
    "data-name": "Group 5261",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8929",
    "data-name": "Path 8929",
    d: "M106.373,269.171H87.632c-.515,0-.784.262-.8.523s.621.523.868.785l3.755,2.528a2.507,2.507,0,0,1,1.054,2.442l.38,52.84a2.743,2.743,0,0,1-1.265,2.441l-3.974,2.529c-.273.349-.924.523-.936.784s.235.523.75.523h16.077c13.011,0,21-5.929,22.225-34.355.976-22.583-6.387-31.041-19.4-31.041m8.835,31.041c-1.153,26.681-6.063,29.995-11.087,29.995H101.8l2.45-56.676h2.319c5.024,0,9.647,3.313,8.637,26.681",
    transform: "translate(-44.854 -139.224)",
    fill: "#d3d3d3",
    fillRule: "evenodd"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5264",
    "data-name": "Group 5264"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5263",
    "data-name": "Group 5263",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8930",
    "data-name": "Path 8930",
    d: "M208.224,49.9c-1.1-10.015-8.707-18.739-20.972-21.173-3.811-14.126-20.222-24.8-39.89-24.716-22.845.093-35.215,8.946-39.236,21.262a23.781,23.781,0,0,0-7.144,8.037C82.353,34.479,67.706,46.458,67.706,61.073a21.75,21.75,0,0,0,.7,5.471C65.629,68.6,64,71.081,64,73.76,64,80.8,75.229,86.506,89.082,86.506h.07a45.528,45.528,0,0,0,14.819,2.434,46.921,46.921,0,0,0,7.931-.676c7.549,3.874,17.6,6.238,28.624,6.238a66.334,66.334,0,0,0,25.506-4.784c.685.021,1.375.034,2.069.034a58.921,58.921,0,0,0,20.075-3.368,33.378,33.378,0,0,0,10.4,1.63c14.43,0,26.127-8.844,26.127-19.755,0-8.332-6.825-15.454-16.477-18.357",
    transform: "translate(-33.102 -2.074)",
    fill: "#fff",
    fillRule: "evenodd"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5266",
    "data-name": "Group 5266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5265",
    "data-name": "Group 5265",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8931",
    "data-name": "Path 8931",
    d: "M207.06,47.355c-2.433-19.349-15.468-22.072-20.74-22.246C158.976-17.645,115.3,7.15,115.3,7.15c-5.33,3.824-2.2,3.592,2.563,1.565,37.734-14.027,60.062,11.883,64.29,16.626-4.866.232-13.151,6.083-11.625,7.523,23.4-14.7,32.368,8.633,32.365,14.027-3.476,0-8.458,1.332-9.385,3.592,15.41-5.214,32.094,5.677,24.215,23.057S183.771,84.2,179.6,79.217c-.869-.463-2.549-.463,1.275,3.708-7.068,2.781-14.251,2.433-18.422,2.317-31.863,11.007-47.62,1.854-53.413-.811-12.166,2.781-23.173-1.043-26.3-1.97,1.622-.7,4.4-2.549,4.171-4.635C82.854,82.114,76.25,81.3,73.585,80.839c-20.276-3.592-10.544-14.251-7.763-17.032-2.2-33.137,31.167-31.283,37.308-30.7-3.36-2.317-1.738-1.159-5.446-2.9,6.188-8.776,17.072-10.231,17.7-10.308a28.075,28.075,0,0,1,.61-2.785c-14.6,3.708-19.813,10.08-22.211,12.581-38.207,2.089-32.406,28.808-31.2,34-17.75,16.741,8.276,22.588,19.233,21.2,6.025,3.012,21.319,3.592,26.175,2.852,26.974,15.571,52.333,2.793,55.625.972,9.49,2.22,23.227-2.45,22.709-2.781,0,0,29.082,7.531,37.192-11.123S213.2,48.05,207.06,47.355M115.412,19.9l-.03,0c0,.078.03,0,.03,0",
    transform: "translate(-29.249 0)",
    fill: "#d3d3d3",
    fillRule: "evenodd"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5268",
    "data-name": "Group 5268"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5267",
    "data-name": "Group 5267",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8932",
    "data-name": "Path 8932",
    d: "M152.858,191.744a4.36,4.36,0,0,0-5.636,2.5l-8.774,22.79a4.36,4.36,0,1,0,8.138,3.134l8.774-22.79a4.361,4.361,0,0,0-2.5-5.637",
    transform: "translate(-71.459 -99.025)",
    fill: "#d3d3d3",
    fillRule: "evenodd"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5270",
    "data-name": "Group 5270"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5269",
    "data-name": "Group 5269",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8933",
    "data-name": "Path 8933",
    d: "M236.065,221.246c-2.247-.866-5.35.139-6.215,2.387l-8.774,22.79c-.865,2.248.834,4.887,3.082,5.753a4.36,4.36,0,0,0,5.636-2.5l8.774-22.79a4.361,4.361,0,0,0-2.5-5.637",
    transform: "translate(-114.229 -114.276)",
    fill: "#d3d3d3",
    fillRule: "evenodd"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5272",
    "data-name": "Group 5272"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5271",
    "data-name": "Group 5271",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8934",
    "data-name": "Path 8934",
    d: "M298.043,188.773a3,3,0,0,0-3.881,1.73l-6.043,15.752a3,3,0,1,0,5.605,2.166l6.043-15.752a3.018,3.018,0,0,0-1.723-3.9",
    transform: "translate(-148.921 -97.536)",
    fill: "#d3d3d3",
    fillRule: "evenodd"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5274",
    "data-name": "Group 5274"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5273",
    "data-name": "Group 5273",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8935",
    "data-name": "Path 8935",
    d: "M329.723,208.693a3,3,0,0,0-3.881,1.73L319.8,226.175a3,3,0,1,0,5.6,2.166l6.043-15.752a3.018,3.018,0,0,0-1.724-3.9",
    transform: "translate(-165.307 -107.839)",
    fill: "#d3d3d3",
    fillRule: "evenodd"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_5276",
    "data-name": "Group 5276"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5275",
    "data-name": "Group 5275",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8936",
    "data-name": "Path 8936",
    d: "M105.167,191.875a2.744,2.744,0,0,0-3.546,1.573L96.1,207.776a2.743,2.743,0,0,0,5.12,1.97l5.52-14.328a2.741,2.741,0,0,0-1.574-3.544",
    transform: "translate(-49.612 -99.149)",
    fill: "#d3d3d3",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBDouin);
export default __webpack_public_path__ + "static/media/Logo_BDouin.476991d005c5332f18508a55d4bc0285.svg";
export { ForwardRef as ReactComponent };